import "./style.css";
import Header from "./components/Header";
import Footer from "./components/Footer";

export default function App() {
    return (
        <div className="w-full mx-auto overflow-x-hidden">

            <header id="home" className="relative w-full">
                <Header />
            </header>
            <Footer />
        </div>
    );
}
